import React, { useState } from 'react';

function PostCard({ post, user, comments, users, showComments, onLike, onBookmark, onComment, onToggleComments, formatRelativeTime, formatNumber }) {
  const [commentText, setCommentText] = useState('');

  const handleSubmitComment = () => {
    if (!commentText.trim()) return;
    onComment(commentText.trim());
    setCommentText('');
  };

  return (
    <div className="social-post">
      {/* Post Header */}
      <div className="social-post-header">
        <div className="social-post-user">
          <span className="social-post-avatar">{user.avatar}</span>
          <div className="social-post-user-info">
            <span className="social-post-name">
              {user.name}
              {user.verified && <span className="social-verified" title="Verified">✓</span>}
            </span>
            <span className="social-post-handle">{user.handle} · {formatRelativeTime(post.timestamp)}</span>
          </div>
        </div>
        <button className="social-post-menu" title="More options">···</button>
      </div>

      {/* Post Body */}
      <div className="social-post-body">
        <p className="social-post-text">{post.text}</p>
        {post.image && (
          <div className="social-post-image">
            <span className="social-post-image-emoji">{post.image}</span>
            {post.imageLabel && <span className="social-post-image-label">{post.imageLabel}</span>}
          </div>
        )}
      </div>

      {/* Post Stats */}
      <div className="social-post-stats">
        <span>{formatNumber(post.likes)} likes</span>
        <span>{formatNumber(post.comments)} comments</span>
        <span>{formatNumber(post.shares)} shares</span>
      </div>

      {/* Post Actions */}
      <div className="social-post-actions">
        <button className={`social-action-btn ${post.liked ? 'liked' : ''}`} onClick={onLike}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill={post.liked ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2">
            <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
          </svg>
          <span>Like</span>
        </button>
        <button className="social-action-btn" onClick={onToggleComments}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
          </svg>
          <span>Comment</span>
        </button>
        <button className="social-action-btn">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" />
            <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
            <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
          </svg>
          <span>Share</span>
        </button>
        <button className={`social-action-btn ${post.bookmarked ? 'bookmarked' : ''}`} onClick={onBookmark}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill={post.bookmarked ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2">
            <path d="M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2z" />
          </svg>
          <span>Save</span>
        </button>
      </div>

      {/* Comments Section */}
      {showComments && (
        <div className="social-comments">
          {comments.map((comment) => {
            const commentUser = users[comment.userId] || { name: 'Unknown', avatar: '👤' };
            return (
              <div key={comment.id} className="social-comment">
                <span className="social-comment-avatar">{commentUser.avatar}</span>
                <div className="social-comment-body">
                  <div className="social-comment-bubble">
                    <span className="social-comment-name">{commentUser.name}</span>
                    <span className="social-comment-text">{comment.text}</span>
                  </div>
                  <div className="social-comment-meta">
                    <span>{formatRelativeTime(comment.timestamp)}</span>
                    <button className="social-comment-like">Like ({comment.likes})</button>
                    <button className="social-comment-reply-btn">Reply</button>
                  </div>
                </div>
              </div>
            );
          })}
          <div className="social-comment-input">
            <span className="social-comment-avatar">{users.user1.avatar}</span>
            <input
              type="text"
              placeholder="Write a comment..."
              value={commentText}
              onChange={(e) => setCommentText(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSubmitComment()}
            />
            <button
              className={`social-comment-send ${commentText.trim() ? 'active' : ''}`}
              onClick={handleSubmitComment}
              disabled={!commentText.trim()}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="22" y1="2" x2="11" y2="13" />
                <polygon points="22 2 15 22 11 13 2 9 22 2" />
              </svg>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default PostCard;
